import { MODALS } from 'common/domain/constants';
import { ROUTES } from 'common/domain/routes';
import { AUTHENTICATION_PORTAL_URL } from '../../common/endpoints/endpoints.constants';

class AuthenticationController {

  constructor(AuthenticationService, $cookies, $location, $log, $translate, $state, $window) {
    'ngInject';
    this.location = $location;
    this.log = $log;
    this.authenticationService = AuthenticationService;
    this.params = $location.search();
    this.translate = $translate;
    this.cookies = $cookies;
    this.state = $state;
    this.window = $window;
  }

  $onInit() {
    this._authenticateAndRedirect();
    this._translate();
  }

  _translate(){
    this.translate('GLOBALS.AUTHENTICATION_ERROR').then((translation) => {
      this.title = translation;
    });
    this.translate('GLOBALS.BUTTON_ACTION.TRY_AGAIN').then((translation) => {
      this.buttonText = translation;
    });
  }

  _authenticateAndRedirect() {
    if (this.params.isPortalSenior && this.params.isPortalSenior === 'true') {
      this.log.log('PortalSenior Auth with params: ', this.params); 
      this.cookies.put('isPortalSenior', true);
      if (this.params.token && this.params.employeeId) {
        return this.authenticationService.authenticatePortal(this.params.token, this.params.employeeId)
        .then(()=> {
          this.log.log('PortalSenior: authentication.controller: authenticated', this.params.token);
          this._redirectToLoans();
        }, error => {
          this.log.log('PortalSenior: authentication.controller: error authenticate token', this.params.token);
          this.description = error.data;
          this.openModal();
        });
      }
      else {
        this.log.log('redirecting to AUTHENTICATION_PORTAL_URL');
        this.window.location.href = AUTHENTICATION_PORTAL_URL;
      }
    }
    else{
      this.cookies.put('isPortalSenior', false);

      if (this.params.token === undefined || this.params.target === undefined) {
        this.openModal();
        return;
      }
  
      this
        .authenticationService
        .authenticate(this.params.token, this.params.target)
        .then(() => {
          this.log.log('authentication.controller: authenticated', this.params.token);
          this._redirectToTarget();
        }, error => {
          this.log.log('authentication.controller: error authenticate token', this.params.token);
          this.description = error.data;
          this.openModal();
        });
    }

  }

  openModal() {
    $(MODALS.AUTHENTICATION_ERROR_MODAL).modal('show');
  }

  retry(){
    if (this.cookies.get('isPortalSenior') === 'true') {
      window.location.href = AUTHENTICATION_PORTAL_URL;
    }
    else {
      this.authenticationService.redirectToLogin();
    }
  }

  _redirectToTarget(){
    let defaultRedirect = ROUTES.ERROR;
    if (process.env.isDev) {
      defaultRedirect = ROUTES.INDEX;
    }
    if (Array.isArray(this.params.target)) {
      const validTarget = this.params.target.find(t => t !== 'error') || defaultRedirect;
      this.params.target = validTarget;
    }
    this.params.target = this.params.target || defaultRedirect;
    this.location.url(this.params.target);
  }

  _redirectToLoans(){
    this.log.log('authentication.controller (PortalSenior): redirect to loans');
    this.location.url('loans');
    // this.state.go(STATES.LOANS.CREDITWORTHINESS);
    // this.location.url(ROUTES.LOANS.ROOT + ROUTES.LOANS.CREDITWORTHINESS);
  }
}

export default AuthenticationController;



// WEBPACK FOOTER //
// ./client/app/features/authentication/authentication.controller.js